import { useCallback, useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

import './payments.css';
import iconExclamacion from './iconExclamacion.svg';
import iconExclamacionExcede from './iconExclamacionExcede.svg';
import iconExclamacionAbono from './iconExclamacionAbono.svg';
import iconPagar from './iconPagar.svg';

import { Buy } from '../../models/buy'
import { usePay } from '../../hooks/usePay'
import { emit } from '../../utils/eventBus';

export const PaymentsForm = ({ setModal, initialPay, checkInitialData, initGetAllPayByGasto }) => {

    const [showAccount, setShowAccount] = useState(false)
    const [tiposDePagos, setTiposDePagos] = useState([])
    const [cuentasBancarias, setCuentasBancarias] = useState([])
    const [msgError, setMsgError] = useState('')

    const { listSuppliers } = useSelector(state => state.contacts)
    const { detailPay, initSavePay, initUpdatePay } = usePay()
    const [form, setForm] = useState(initialPay)

    const getInfoBancaria = async () => {
        const dataResult = await Buy.getInfoBancaria()
        setTiposDePagos(dataResult.tipos_pagos)
        setCuentasBancarias(dataResult.ctas_bancarias)
    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        });
    }

    const handleChangeDate = (date) => {
        setForm({
            ...form,
            'fecha_pago': date,
        });
    }

    const handleChangeMonto = (value) => {
        setForm({
            ...form,
            'total_pago': value.floatValue,
        });
    }

    const selectedSuplier = useCallback((id = null) => {
        if (id) {
            const foundInfo = listSuppliers.find(s => s.id === id);
            if (foundInfo) {
                setForm(prev => ({
                    ...prev,
                    'proveedor': foundInfo.nombre,
                }))
            }
        }
    }, [listSuppliers])

    const handleSave = async () => {

        if (form.total_pago === 0) {
            setMsgError('Ingrese un monto válido')
            return false
        }

        if (form.total_pago > form.compra_total_por_pagar) {
            setMsgError('Monto supera al saldo por pagar')
            return false
        }

        if (form.id === 0) {
            await initSavePay(form)
        }

        if (form.id > 0) {
            await initUpdatePay(form)
        }

        // solo cuando accede desde la lista
        if (typeof initGetAllPayByGasto !== 'undefined') {
            await initGetAllPayByGasto(form.id_compra)
        }

        setForm(detailPay)
        await checkInitialData(form.id_compra)
        setModal(false)

        emit("flows_updated");

    }

    useEffect(() => {
        getInfoBancaria()
    }, [])

    useEffect(() => {
        selectedSuplier(form.id_proveedor);
    }, [selectedSuplier, form.id_proveedor])

    return (
        <div className="row p-payments-form">
            <div className="col">

                <div className="row">
                    <div className="col">
                        <TextField
                            label="Proveedor"
                            disabled={true}
                            name="proveedor"
                            id="outlined-size-small"
                            value={form.proveedor || ''}
                            size="small"
                            fullWidth
                            placeholder='Proveedor'
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col">

                        {form.id > 0 ?
                            <NumberFormat
                                disabled={true}
                                className={`text-end monto normal`}
                                value={form.total_pago}
                                thousandSeparator={form.separacion_miles}
                                decimalSeparator={form.separacion_decimales}
                                prefix={`${form.simbolo} `}
                                onValueChange={(values) => handleChangeMonto(values, 'total_pago')}
                                decimalScale={2}
                            />
                            :
                            <NumberFormat
                                // disabled={((form.id > 0 ? true : false) || (form?.items_to_pay?.length > 0))}
                                disabled={(form.id > 0 ? true : false)}
                                className={`text-end monto text-black ${form.total_pago > form.compra_total_por_pagar ? ' excede' : (form.total_pago < form.compra_total_por_pagar ? 'abono' : 'normal')}`}
                                value={form.total_pago}
                                thousandSeparator={form.separacion_miles}
                                decimalSeparator={form.separacion_decimales}
                                prefix={`${form.simbolo} `}
                                onValueChange={(values) => handleChangeMonto(values, 'total_pago')}
                                decimalScale={2}
                            />

                        }

                        <span className='info d-flex justify-content-start align-items-center'>

                            {(form.total_pago === form.compra_total_por_pagar && form.id === 0) &&
                                <>
                                    <img src={iconExclamacion} alt="pago total" />
                                    <label className='normal'>Puedes abonar el monto completo o de forma parcial</label>
                                </>
                            }

                            {(form.total_pago > form.compra_total_por_pagar && form.id === 0) &&
                                <>
                                    <img src={iconExclamacionExcede} alt="excede total" />
                                    <label className='excede'>El monto ingresado sobrepasa el total del gasto</label>
                                </>
                            }

                            {(form.total_pago < form.compra_total_por_pagar && form.id === 0) &&
                                <>
                                    <img src={iconExclamacionAbono} alt="pago parcial" />
                                    <label className='abono'>El monto ingresado es un abono del total del gasto</label>
                                </>
                            }

                        </span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="Fecha de pago"
                                inputFormat="dd/MM/yyyy"
                                name="fecha_pago"
                                value={form.fecha_pago || ''}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </div>
                </div>

                {showAccount &&
                    <>
                        <div className="row">
                            <div className="col">
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Tipo de pago</InputLabel>
                                    <Select
                                        label="Tipo de pago"
                                        id="id_tipo_pago"
                                        name="id_tipo_pago"
                                        value={form.id_tipo_pago || ''}
                                        onChange={handleChange}
                                        className='p-list-capitalize'
                                    >
                                        <MenuItem value='' key=''>Ninguno</MenuItem>
                                        {tiposDePagos.map(item => (
                                            <MenuItem value={item.id} key={item.id}>{item.nombre}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Cuenta bancaria</InputLabel>
                                    <Select
                                        label="Cuenta bancaria"
                                        id="id_cuenta"
                                        name="id_cta_bancaria"
                                        value={form.id_cta_bancaria || ''}
                                        onChange={handleChange}
                                        className='p-list-capitalize'
                                    >
                                        <MenuItem value='' key=''>Ninguno</MenuItem>
                                        {cuentasBancarias.map(item => (
                                            <MenuItem value={item.id} key={item.id}>{item.nombre}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <TextField
                                    label="N° de operación"
                                    name="numero_operacion"
                                    id="outlined-size-small"
                                    value={form.numero_operacion || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese número operación'
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col ">
                                <div style={{ fontSize: '14px' }}>Adjunta enlace del boucher de pago (opcional)</div>
                                <div style={{ fontSize: '14px', color: 'gray' }}>Te facilita el seguimiento para futuras revisiones.</div>
                                <div className='mt-2'>
                                    <input
                                        type="url"
                                        style={{
                                            width: '100%',
                                            border: '0px',
                                            borderBottom: '1px solid lightgray',
                                            padding: '5px',
                                            fontSize: '13px',
                                            outline: 'none'
                                        }}
                                        onChange={handleChange}
                                        placeholder='Ingrese enlace del archivo'
                                        name="url_boucher"
                                        value={form?.url_boucher || ''}
                                    />
                                </div>
                            </div>
                        </div>

                    </>
                }

                {msgError !== '' &&
                    <div className='mt-2' style={{ color: 'red' }}>{msgError}</div>
                }

                <div className="row d-flex align-items-center">
                    <div className="col-7 agregar-datos" onClick={() => setShowAccount(!showAccount)}>
                        {showAccount ? 'Ocultar datos bancarios' : 'Agregar datos bancarios'}
                    </div>
                    <div className="col-5">
                        <button className='btn flex justify-content-center items-center' onClick={handleSave} style={{ width: '130px' }}>
                            <img src={iconPagar} alt="pagar gasto" className="w-[20px] h-[20px]" />
                            <label>{form.id > 0 ? 'Actualizar' : 'Pagar'}</label>
                        </button>
                    </div>
                </div>


            </div>
        </div>
    )

}